import { render } from "./news.vue?vue&type=template&id=39400f44"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=39400f44&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__